import alert from '../assets/alert.svg';
import type { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
};

export function AlertBanner({ children, className = '' }: Props) {
    return (
        <div
            className={`flex w-full items-center gap-3 rounded-lg border border-red-200 bg-red-100 px-4 py-3 text-sm font-medium text-red-600 ${className}`}
            role="alert"
        >
            <img src={alert} alt="alert" className="h-5 w-5 shrink-0" loading="lazy" />
            <span>{children}</span>
        </div>
    );
}
